module.exports = global.config = {
    api: {
        url: {
            live: "https://api.fruma.is",
            local: "http://localhost:8888/api.fruma"
        }
    }
};
